import { scrollToId } from 'lib/window/scrollUtils'
import { useCallback, useEffect, useState } from 'react'

function useScrollToId(id: string, offset = 0) {
  const [hasLoadedScrollElement, setHasLoadedScrollElement] = useState<boolean>(false)

  useEffect(() => {
    const element = document.getElementById(id)
    if (element && !hasLoadedScrollElement) {
      setHasLoadedScrollElement(true)
    }
  }, [id, hasLoadedScrollElement])

  const onScrollToId = useCallback(() => {
    if (hasLoadedScrollElement) {
      return scrollToId(id, offset)
    }
  }, [hasLoadedScrollElement, id, offset])

  return {
    onScrollToId,
    hasLoadedScrollElement,
  }
}

export default useScrollToId
